import "@lds/core/lds-select.js"
import "@lds/core/lds-option.js"
import "@lds/core/lds-dropdown.js"

import "./pagination/pagination.ts"
import "../global/pagination/pagination.css"
import "./pagination/index.ts"
import "./pagination/buttons.ts"
import "./pagination/select.ts"

import "../events-slider/events-slider.ts"
import "../events-slider/events-slider.css"

import "../news/advert-banners.ts"
import "../azm/advert-cards.css"

import {
    setAZMFilterPath,
    setFilterPathLocationToSessionStorage,
} from "@modules/global/filter-path/filter-path-handler.ts"
import { initBottomAnnouncements as initBottomAnnouncementsAPI } from "@modules/news/bottom-announcements-api.ts"

import { initTopAnnouncements as initAnnouncementAPI } from "@modules/news/top-announcements-api.ts"
import { initTopAnnouncements } from "@modules/news/top-announcements.ts"
setFilterPathLocationToSessionStorage("news")
setAZMFilterPath()

if (SiteInfo.isAnnouncementsApiActive) {
    document.addEventListener("DOMContentLoaded", initAnnouncementAPI)
} else {
    document.addEventListener("DOMContentLoaded", initTopAnnouncements)
}

initBottomAnnouncementsAPI().then()
